export const APP_PATHS = {
  root: '/',
  tasks: '/tasks',
  memory: '/memory',
  calendar: '/calendar',
  lists: '/settings/lists',
  info: '/info',
  line: '/line',
  settings: '/settings',
  briefing: '/settings/heartbeat',
  knowledge: '/knowledge',
  routing: '/routing',
  monitor: '/monitor',
  campaigns: '/campaigns',
  contacts: '/contacts',
  outboundPerformance: '/outbound-performance',
  compliance: '/compliance',
  accounts: '/accounts',
} as const

export const PUBLIC_PATHS = {
  home: '/',
  pricing: '/pricing',
  about: '/about',
  waitlist: '/waitlist',
  deprecatedClaim: '/c/:token',
  sharedCall: '/shared/call/:token',
  embedCall: '/embed/:token',
} as const

export const AUTH_PATHS = {
  login: '/login',
  verify: '/verify/:token',
  recover: '/recover/:token',
  forgotAccess: '/forgot-access',
  qrAuth: '/qr-auth/:sessionToken',
} as const
